import type { MouseEvent } from 'react';
import styled from 'styled-components';
import { CloseBold } from '@elfsight/icons';
import { useIsMobile } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { StopDisplayTriggerTypes, useBarState } from '../bar-state-provider';

export const CloseButton = ({
  barHeight,
  onClose
}: {
  barHeight?: number;
  onClose(): void;
}) => {
  const { closeButton, messageColor } = useSettings();
  const { closeBar, stopDisplayTrigger } = useBarState();

  const isMobile = useIsMobile();

  const closeButtonHandler = (event: MouseEvent<HTMLOrSVGElement>) => {
    event.stopPropagation();
    stopDisplayTrigger(StopDisplayTriggerTypes.CLOSEDBAR);
    closeBar();
    onClose();
  };

  if (!closeButton) return null;

  return (
    <CloseButtonContainer
      onClick={closeButtonHandler}
      _isMobile={isMobile}
      _isFixed={!!barHeight && barHeight > 80}
    >
      <StyledCloseIcon fill={messageColor} _color={messageColor} />
    </CloseButtonContainer>
  );
};

const StyledCloseIcon = styled(CloseBold)<{ _color: string }>`
  width: 12px;
  height: 12px;
  fill: ${({ _color }) => _color};
`;

export const CloseButtonContainer = styled.div<{
  _isFixed: boolean;
  _isMobile: boolean;
}>`
  cursor: pointer;
  display: flex;
  width: 24px;
  height: 24px;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: ${({ _isMobile }) => (_isMobile ? '8px' : '10px')};
  top: ${({ _isFixed }) => (_isFixed ? '10px' : '50%')};
  ${({ _isFixed }) => !_isFixed && 'transform: translateY(-50%)'};

  bottom: ${({ _isFixed }) => (_isFixed ? 'unset' : 0)};
`;
